export function inputAutoFill() {
  $("#zip-button").on("click", function () {
    AjaxZip3.zip2addr("zip-code", "", "address", "address");

    //成功時に実行する処理
    AjaxZip3.onSuccess = function () {
      $(".addr").focus();
    };

    //失敗時に実行する処理
    AjaxZip3.onFailure = function () {
      alert("郵便番号に該当する住所が見つかりません");
    };

    return false;
  });
}

export function errorMessage() {
  $('.wpcf7-form-control-wrap[data-name="consultation"]').each(function () {
    const targetNode = this;
    const observer = new MutationObserver(function () {
      if ($(targetNode).find(".wpcf7-not-valid-tip").length > 0) {
        $(".p-general-inquiry-form__contents .wpcf7-not-valid-tip").hide();
        $(".p-general-inquiry-form__checkbox-error-txt").text(
          "ご相談内容は必須です。"
        );
      } else {
        $(".p-general-inquiry-form__checkbox-error-txt").text("");
      }
    });
    observer.observe(targetNode, {
      childList: true,
      subtree: true,
    });
  });
}

export function setConsultationCode() {
  $("form").on("change", 'input[name="consultation"]', function () {
    // 「p-general-inquiry-form__consultation-」を含む class を持つ一番近い親要素を取得
    var targetClass = $(this)
      .closest('[class*="p-general-inquiry-form__consultation-"]')
      .attr("class");

    if (!targetClass) return;

    // class 属性から該当部分を抜き出す
    var match = targetClass.match(
      /p-general-inquiry-form__consultation-([a-zA-Z0-9_-]+)/
    );

    if (!match) return;

    const keyword = match[1];
    const value = $(this).val();

    // 送信用データ（連想配列）
    const data = {
      value: value,
      keyword: keyword,
    };

    // JSON 文字列にして hidden にセット
    $('input[name="consultation-type"]').val(JSON.stringify(data));
  });
}
